import type { TaskBodyProps } from './index';
import { DesignPlanHistory } from './DesignPlanHistory';
import { DesignPatientInfo } from './submit-design/DesignPatientInfo';
import { ClinicalDocPanel } from './submit-design/ClinicalDocPanel';
import { SDI_WIZARD_CONFIG } from '../../patient-files/actions/sdi/sdiWizardConfig';

// Init - 10.2 "Submit for manufacturing" (and V2 Init - 10.1 "Review SDI") — mirrors Ref-7's
// submit task, but shows the SDI (not the RDI) and the initial design submissions.
export function SdiSubmitManufacturingTask({ workCase: c }: TaskBodyProps) {
    return (
        <div className="flex-1 min-h-0 flex flex-col px-4 pt-3 pb-3">
            <div className="flex-1 min-h-0 flex gap-3">
                {/* LEFT — submitted Tx design instructions */}
                <div className="flex-[6] min-w-0 flex flex-col">
                    <DesignPlanHistory patientId={c.id} />
                </div>

                {/* RIGHT — patient info over the SDI (in place of the RDI) */}
                <div className="flex-[4] min-w-0 min-h-0 flex flex-col gap-3">
                    <div className="flex-[4] min-h-0">
                        <DesignPatientInfo patientId={c.id} />
                    </div>
                    <div className="flex-[6] min-h-0">
                        <ClinicalDocPanel
                            patientId={c.id}
                            title="SDI"
                            timelineType="sdi_submission"
                            wizardConfig={SDI_WIZARD_CONFIG}
                            openAction="sdi"
                            emptyText="No SDI created yet for this case."
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
